import { z } from "zod";

export const repeaterFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    maxRepetition: z.number(),
});

export type RepeaterFormData = z.infer<typeof repeaterFormSchema>;
